import { render, staticRenderFns } from "./rankingInfo.vue?vue&type=template&id=4525e49e&"
import script from "./rankingInfo.vue?vue&type=script&lang=js&"
export * from "./rankingInfo.vue?vue&type=script&lang=js&"
import style0 from "./rankingInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports